module.exports = __webpack_public_path__ + "img/green.d3f496d9.jpg";